import './landing.css'

import { AlsoInBuild } from './AlsoInBuild.tsx'
import { CodeConsole } from './CodeConsole.tsx'
import { Hero } from './Hero.tsx'
import { HeroGlow } from './HeroGlow.tsx'
import { LandingFooter } from './LandingFooter.tsx'
import { Marquee } from './Marquee.tsx'
import { StartCards } from './StartCards.tsx'

// The portal's landing page, from the BUILD landing design: hero and code
// console side by side, then the three starting points, the stats marquee, the
// platform index, and the footer.
//
// The design mocks a whole screen including a sidebar; the shell already owns
// that chrome (Rail + SessionControl), so this renders only the main pane and
// scrolls it in place — same reason the reference scrolls inside the sheet
// rather than the document (theme/tokens.css).

export const Landing = ({
  onNavigate,
}: {
  onNavigate: (path: string) => void
}) => (
  <div
    style={{
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      position: 'relative',
    }}
  >
    <HeroGlow />

    <div
      style={{
        position: 'relative',
        maxWidth: 1128,
        margin: '0 auto',
        padding: '72px 56px 28px',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '52px 48px',
          alignItems: 'center',
        }}
      >
        <Hero onNavigate={onNavigate} />
        <CodeConsole />
      </div>

      <StartCards onNavigate={onNavigate} />
      <Marquee />
      <AlsoInBuild />
      <LandingFooter />
    </div>
  </div>
)
